/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Academy_ScoreInputs */

const en_academy_score = /** @type {(inputs: Academy_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

const ja_academy_score = /** @type {(inputs: Academy_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得点`)
};

const fr_academy_score = /** @type {(inputs: Academy_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

const de_academy_score = /** @type {(inputs: Academy_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punktzahl`)
};

/**
* | output |
* | --- |
* | "Score" |
*
* @param {Academy_ScoreInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const academy_score = /** @type {((inputs?: Academy_ScoreInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Academy_ScoreInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_academy_score(inputs)
	if (locale === "ja") return ja_academy_score(inputs)
	if (locale === "fr") return fr_academy_score(inputs)
	return de_academy_score(inputs)
});